<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3053_2386)">
<rect x="2.35" y="1.85" width="18.3" height="18.3" rx="2.15" stroke="currentColor" stroke-width="1.7"/>
<path d="M17.3687 8.08309L13.5258 11.8322C13.28 12.072 13.157 12.1919 12.9993 12.2166C12.8416 12.2412 12.688 12.1645 12.3808 12.0111L10.0003 10.8226C9.70444 10.6749 9.55653 10.601 9.40351 10.622C9.25048 10.643 9.12789 10.7539 8.8827 10.9757L5.6313 13.917" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_3053_2386">
<rect width="22" height="22" fill="white" transform="translate(0.5)"/>
</clipPath>
</defs>
</svg>
